import { useAppSelector } from '../../../../redux/hooks';
import { phoneNumberFormatE164 } from 'utils/phoneNumberFormatE164';
import { useInfoStatus } from 'hooks/useInfoStatus';
import { useCallTimers } from 'hooks/useCallTimers';
import { LiveCall } from 'redux/slices/liveCalls.slice';
import CallItemCard from '../CallItemCard';
import './liveCallsItemWrapper.scss'
import React from 'react';

interface LiveCallItemWrapperProps {
  call: LiveCall;
  actions: string[];
  onSelectAction: (key: string) => void;
  onHangUp: () => void;
  onClickCall?: () => void;
}

const LiveCallItemWrapper = ({
  call,
  actions,
  onSelectAction,
  onHangUp,
  onClickCall,
}: LiveCallItemWrapperProps) => {
  const hhaData = useAppSelector((state) => state.hhaexchange.items);
  const { infoText } = useInfoStatus(call);
  const { calculateTimer } = useCallTimers();

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClickCall?.();
    }
  };

  return (
    <li
      key={call.callUUID}
      className={`live-call-item`}
      onClick={onClickCall}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`Call from ${call.callerIDName || 'Unknown'} to ${call.destination || 'Unknown'}`}
      data-testid="live-call-item"
      style={{ cursor: 'pointer' }}
    >
      <CallItemCard
        name={call.callerIDName || 'Unknown'}
        ext={call.callerIDNumber || ''}
        phone={call.destination || 'Unknown'}
        duration={calculateTimer(call.startTime) || ''}
        callDescription={infoText || ''}
        callDirection={call.callDirection ?? ''}
        selectedActions={actions}
        onSelectAction={onSelectAction}
        onHangUp={onHangUp}
        isRecording={call.isRecording || false}
        isThirdParty={
          !!(
            call?.callerIDNumber &&
            hhaData.some(item => {
              const formatted = phoneNumberFormatE164(call.callerIDNumber || '');
              return (
                item.HomePhone === formatted ||
                item.Phone2 === formatted ||
                item.Phone3 === formatted
              );
            })
          )
        }
      />
    </li>
  );
};

export default React.memo(LiveCallItemWrapper);

